import styled from '@emotion/styled'
import { LoadingSVG } from '@oneToOne/shared/assets/LoadingSVG'

export const DocumentIconContainer = styled.div`
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.3));
`

export const PlayIconContainer = styled.div`
  width: 20px;
  min-width: 20px;
  height: 20px;
  background: var(--blk3);
  border-radius: 50%;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.3));
`

export const AnimatedLoadingSVG = styled(LoadingSVG)`
  display: inline-block;
  animation: spin 1s linear infinite;
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
